import Button from '@jetbrains/ring-ui/components/button/button'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import Panel from '@jetbrains/ring-ui/components/panel/panel'
import {useMemo} from 'react'

import styles from './BannerDialog.css'

type Props = {
  show: boolean
  title?: string
  message: string
  onClose: () => void
}
function BannerDialog({show, title, message, onClose}: Props) {
  const headerTitle = useMemo(() => title || message.split(/[^\w\s]/)[0], [title, message])
  return (
    <Dialog contentClassName={styles.container} title={headerTitle} show={show}>
      <Header>{headerTitle}</Header>
      <Content>{message}</Content>
      <Panel>
        <Button primary onClick={onClose}>
          {'Got it'}
        </Button>
      </Panel>
    </Dialog>
  )
}
export default BannerDialog
